export enum SortFields {
  ShiftDate = 'shift_date',
  TransactionDate = 'transaction_date',
}
